/**
 * @module store/state
 */
import { getCookie } from '/src/common/cookie-utils';

export const state = () => ({
  entity: {
    list: [],
    selected: null,
    flattenList: []
  },

  ListDelegatedToCurrentUser: null,
  breadcrumbs: [],
  packageList: [],
  notAuthorizedList: [],
  locale: 'en',
  loadedLanguages: [],
  listOfUrlAndState: [],
  LAST_UPDATE_TIMESTAMPS: {},
  availableLanguages: [],
  hasRouteLoaded: false,
  showFilterPane: false,
  menuItems: [],
  delegateCount: 0,
  forceLogout: 'not-authorized',
  isTasksPage: false,
  miniDrawer: (getCookie('minimise') || false) === 'true',
  dashboardDesignURL: null,
  newDownloadsCount: null,
  previousState: null,
  headTitleTemplate: null,
  platformTheme: null,
  isQuicklink: false,
  toasts: [],
  progress: {}
});
